<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
  <div fxFlex>Edit Event</div>
</h1>
<mat-dialog-content class="mat-typography">
  <app-mat-simple-select
    label="Select Event Type"
    [(ngModel)]="nodeType"
    [selectItems]="data.selectOptions"
  ></app-mat-simple-select>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-button color="primary" cdkFocusInitial (click)="onSave()">Save</button>
  <button type="button" mat-button [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>
